<template minapp='mpx' xlang='wxml'>
  <view class="contact-phone-wrap">
    <from-item isShow="{{isShow}}" 
      isRequired="{{isRequired}}" 
      isRequiredShow="{{isRequiredShow}}" 
      label="手机号码" 
      innerValue="{{innerValue}}"
      nameTips="{{nameTips}}"
    >
      <block slot="input">
        <es-field placeholder="请输入手机号码" wx:model="{{innerValue}}" bind:focus="phoneFocus" bindblur="onBlur" />
      </block>
    </from-item>
    <view class="label-area" bindtap="triggerPopup">
      <view class="label-area-text"> {{currentArea.pre}}</view>
      <image wx:if="{{!isLabelAreaDefault}}" class="label-area-icon" src="{{arrowRight}}"/>
    </view>
    <es-popup  position="bottom" show="{{ showPopup }}">
      <view class="container">
        <view class="area">
          <view wx:for="{{phoneArea}}" class="item text" bindtap="chooseArea(item)"> {{item.name}} </view>
        </view>
        <view class="close text" bindtap="triggerPopup"> 取消 </view>
      </view>
    </es-popup>
  </view>

</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { AES_ECB_DECRYPT } from '@/common/crypto'
  import { hasRequired, phoneValidateConf} from '@/utils'
  import Validator from '@/utils/validator'
  createComponent({
    classes: [],
    data: {
      innerValue:'',
      nameTips:'',
      showPopup:false,
      phoneArea:[
        {type:1,name:"中国(+86)",pre:"(+86)"},
        {type:2,name:"中国香港(+852)",pre:"(+852)"},
        {type:3,name:"中国澳门(+853)",pre:"(+853)"},
        {type:4,name:"中国台湾(+886)",pre:"(+886)"}
      ],
      currentArea:{type:1,name:"中国(+86)",pre:"(+86)"},
      arrowRight:"https://ut-static.udache.com/webx/sfc/dDD1Uq54ssJ1xIHQhiIQv.png"
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow:{
        type: Boolean,
        value: false
      },
      cardType:{
        type:Object
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      },
      isLabelAreaDefault(){
        return this.checkCardTypeAndArea(this.cardType.code)
      }
    },
    methods: {
      //联系电话输入框聚焦
      checkCardTypeAndArea(code){
        return ['1','B','2'].includes(code)
      },
      phoneFocus() {
        this.$trigger( 'phone-focus' )
      },
      onBlur(e){
        const validateConf = phoneValidateConf(this.currentArea)  
        var validator = new Validator()  
        validator.cbAdd(this.innerValue, validateConf, this.item.tips)
        this.nameTips = validator.start()
      },
      chooseArea(opt){
        this.currentArea = opt
        this.triggerPopup()
      },
      triggerPopup(){
        if(!this.isLabelAreaDefault){
          this.showPopup = !this.showPopup
        }
      }
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      phoneNumber(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
      'currentArea.type': {
        immediate: true,
        deep: true,
        handler(val) {
          this.innerValue = '' 
          this.nameTips= ''
        }
      },
      cardType: {
        deep: true,
        handler(newVal,oldVal) {
          const oldCheck = this.checkCardTypeAndArea(oldVal?.code)
          const newCheck = this.checkCardTypeAndArea(newVal?.code)
          if( !oldCheck && newCheck && this.currentArea.type!==1 ) this.currentArea = {type:1,name:"中国(+86)",pre:"(+86)"}
        }
      }
    },
    mounted() {
    }
  })
</script>

<style lang='stylus' scoped>
  .contact-phone-wrap
    position relative
  .label-area
    position absolute
    top 40px
    display flex
    align-items center
    &-text
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 17px
      color #999999
    &-icon 
      width 5.3px
      height 8px
      margin-left 5.3px
  .container
    background #F6F7F8
    border-radius 10px 10px 0 0 
    .area
      .item
        display flex
        justify-content center
        align-items center
        height 48px
        background #FFFFFF
        border-bottom rgba(0, 0, 0, 0.06);
        &:first-child
          border-radius 10px 10px 0 0 
    .close
      display flex
      justify-content center
      align-items center
      height 48px
      background #FFFFFF
      margin-top 8px
    .text
      font-family PingFangSC-Regular;
      font-size 16px
      font-weight normal
      line-height 19px
      text-align center
      letter-spacing 0px
      color rgba(0, 0, 0, 0.84)
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
    }
  }
</script>

